import gql from 'graphql-tag'

export const GET_FUEL_NAME = gql`
  query FuelTypes($filter: GetFuelTypesInput) {
    fuelTypes(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      fuelTypes {
        data {
          name
          category
          fuelTypeId
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const GET_FUEL_TYPES = gql`
  query FuelTypePrices($filter: GetFuelTypePricesInput) {
    fuelTypePrices(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      fuelTypePrices {
        data {
          fuelType {
            fuelTypeId
            name
            category
          }
          price
          description
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const GET_FUEL_TYPE = gql`
  query FuelTypePrice($filter: GetFuelTypePriceInput!) {
    fuelTypePrice(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      fuelTypePrice {
        fuelType {
          fuelTypeId
          name
          category
        }
        price
        description
        hasRelation
      }
    }
  }
`

export const CREATE_FUEL_TYPE = gql`
  mutation CreateFuelTypePrice($input: CreateFuelTypePriceInput!) {
    createFuelTypePrice(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      fuelTypePrice {
        price
        description
        fuelType {
          name
          fuelTypeId
          category
        }
      }
    }
  }
`

export const UPDATE_FUEL_TYPE = gql`
  mutation UpdateFuelTypePrice($input: UpdateFuelTypePriceInput!) {
    updateFuelTypePrice(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      fuelTypePrice {
        fuelType {
          fuelTypeId
          name
          category
        }
        price
        description
      }
    }
  }
`

export const DELETE_FUEL_TYPE = gql`
  mutation DeleteFuelTypePrice($input: DeleteFuelTypePriceInput!) {
    deleteFuelTypePrice(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      fuelTypePrice {
        price
        description
        fuelType {
          fuelTypeId
          name
          category
        }
      }
    }
  }
`
